//import { useEffect } from 'react'
import {signinRedirect} from '../../Authorization/authService'
import {Container} from '@sainsburys-tech/luna-grid'
import {Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {OutlinedButton} from '@sainsburys-tech/luna-button'
import {Card} from '@sainsburys-tech/luna-card'
import './login.scss'
import {Sainsburys} from '@sainsburys-tech/luna-images'

const Login = () => {
  const user = useSelector((state: any) => state.auth.user)

  // useEffect(()=>{
  //   if(user===null){
  //     signinRedirect()
  //   }
  // },[user])

  const login = () => {
    signinRedirect()
  }

  return (
      (user) ?
          (<Redirect to={'/'}/>)
          :
          (
              <>
                <Card className="fullHeight ln-u-bg-color-grey-light">
                  <Container className="loginBox ln-u-text-align-center" size="lg">
                    <div data-test='login-btn'>
                      <Sainsburys
                          aria-label="Sainsbury's logo"
                          style={{verticalAlign: 'middle', width: '30%'}}
                      />
                      <h4 className="ln-u-color-brand-1 login-heading"
                          data-test='ldm-heading'>Logistics Data Management</h4>
                      <OutlinedButton className="login-button" onClick={() => login()}>
                        Login
                      </OutlinedButton>
                    </div>
                  </Container>
                </Card>

              </>
          )
  )
}

export default Login
